import { isBrowser } from './platform'
import { useEffect } from 'react'

export const useDisableBodyScroll = (open: boolean) => {
  useEffect(() => {
    if (!isBrowser) {
      return
    }
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [open])
}

const useLocalStorage = (key: string, defaultValue?: string) => {
  if (!isBrowser) {
    return defaultValue
  }

  const result = localStorage.getItem(key) ?? defaultValue

  try {
    return result && JSON.parse(result)
  } catch {
    return undefined
  }
}

export const useLoggedUsername = () => useLocalStorage('username')

const logout = () => {
  if (!isBrowser) {
    return
  }
  localStorage.removeItem('userdata')
  localStorage.removeItem('username')
  localStorage.removeItem('user_data')
  localStorage.removeItem('auth')
  window.sessionStorage.removeItem('auth_token')
  window.location.reload()
}

export const useOnLogout = () => logout

export { useMenuVisible } from './platform'
